import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as n, normalizeClass as o, createElementVNode as d } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLinkedin",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(a, i, l, f, _, e) {
  return r(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--linkedin"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Linkedin",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...i[0] || (i[0] = [
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.52 2H3.476C2.662 2 2 2.646 2 3.441v17.116C2 21.354 2.662 22 3.476 22H20.52c.816 0 1.481-.646 1.481-1.443V3.441C22 2.646 21.335 2 20.52 2",
      fill: "#006087"
    }, null, -1),
    d("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.449 4.755a1.72 1.72 0 1 1-.004 3.441 1.72 1.72 0 0 1 .004-3.441ZM4.965 19.05h2.967V9.5H4.965v9.549ZM9.792 9.5h2.845v1.306h.04c.396-.751 1.364-1.542 2.807-1.542 3.004 0 3.558 1.977 3.558 4.548v5.238h-2.964v-4.644c0-1.107-.02-2.532-1.541-2.532-1.544 0-1.78 1.207-1.78 2.452v4.724H9.791V9.5Z",
      fill: "#FFFFFE"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=linkedin.js.map
